import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[HazardStatus SetFilter] Action',
  ResetFilter: '[HazardStatus ResetFilter] Action',
}

const initialHazardStatusState: IHazardStatusState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IHazardStatusState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-HazardStatus', whitelist: ['filter']},
  (
    state: IHazardStatusState = initialHazardStatusState,
    action: ActionWithPayload<IHazardStatusState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialHazardStatusState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
